import React from 'react';
import { Card } from './ui/card';
import { Baby, Smile, BookOpen, GraduationCap } from 'lucide-react';

const ProgramsSection = () => {
  const programs = [
    {
      icon: Baby,
      title: 'Playgroup',
      age: '2-3 years',
      description: 'Introduction to social skills, sensory play, and basic motor development through fun activities.',
      color: 'var(--primary-blue)',
      image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/oev5olnt_WhatsApp%20Image%202026-07-22%20at%2011.39.59%20%281%29.JPG',
    },
    {
      icon: Smile,
      title: 'Nursery',
      age: '3-4 years',
      description: 'Building communication skills, creativity, and early learning concepts through interactive play.',
      color: 'var(--primary-red)',
      image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/kstr3631_WhatsApp%20Image%202026-07-22%20at%2011.40.04.jpeg',
    },
    {
      icon: BookOpen,
      title: 'LKG & UKG',
      age: '4-6 years',
      description: 'Foundation in reading, writing, numbers, and social development with structured activities.',
      color: 'var(--primary-green)',
      image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/eei6tlsw_WhatsApp%20Image%202026-07-19%20at%2017.29.58.jpeg',
    },
    {
      icon: GraduationCap,
      title: '1st Class',
      age: '6-7 years',
      description: 'Formal education begins with comprehensive curriculum covering all core subjects.',
      color: 'var(--primary-orange)',
      image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/heiai7vj_WhatsApp%20Image%202026-07-27%20at%2012.51.42%20%281%29.jpeg',
    },
  ];

  return (
    <section id="programs" className="py-20" style={{ backgroundColor: 'var(--surface-cream)' }}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold heading-playful mb-4" style={{ color: 'var(--primary-red)' }}>
              Our Programs
            </h2>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
              Age-appropriate learning programs designed for every stage of your child's early development.
            </p>
            <div className="w-24 h-1 mx-auto mt-4 rounded-full" style={{ backgroundColor: 'var(--primary-blue)' }}></div>
          </div>

          {/* Programs Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            {programs.map((program, index) => (
              <Card
                key={index}
                className="overflow-hidden rounded-3xl border-0 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                style={{ backgroundColor: 'white' }}
              >
                {/* Real School Image */}
                <div className="relative h-64 overflow-hidden bg-gray-50">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-contain"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
                  <div className="absolute bottom-4 left-4 z-10">
                    <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ backgroundColor: program.color }}>
                      <program.icon className="h-8 w-8 text-white" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-3xl font-bold heading-playful" style={{ color: 'var(--text-primary)' }}>
                      {program.title}
                    </h3>
                    <span className="px-4 py-2 rounded-full text-sm font-bold" style={{ backgroundColor: program.color, color: 'white' }}>
                      {program.age}
                    </span>
                  </div>
                  <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                    {program.description}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
